export default __webpack_public_path__ + "static/media/buyable-logo.f876271b.svg";